import * as React from "react";
import { forwardRef } from "react";
const CaretRightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  "data-category": "arrows",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.58342 15.63c-.51123-.4933-.51123-1.2931 0-1.7863L9.63957 8 3.58342 2.15635c-.51123-.4933-.51123-1.293087 0-1.786379.51123-.493294 1.3401-.493294 1.85134 0L12.4166 7.10681c.5112.4933.5112 1.29308 0 1.78638L5.43476 15.63c-.51124.4933-1.34011.4933-1.85134 0",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(CaretRightIcon);
ForwardRef.category = "arrows";
export { ForwardRef as CaretRightIcon };